<c-container fluid>
  <c-row class="justify-content-center">
    <c-col xs="12" lg="8" xl="7">
      <c-card class="mb-4">
        <c-card-header>
          <strong>{{ 'kyc_form_title' | translate }}</strong>
        </c-card-header>

        <c-card-body>
          <!-- Success state -->
          @if (success()) {
            <c-alert color="success">
              <strong>{{ 'kyc_success_title' | translate }}</strong><br>
              {{ 'kyc_success_message' | translate }}
            </c-alert>
          }

          <!-- Form -->
          @if (!success()) {
            <p class="mb-4" style="color: rgba(255,255,255,0.7)">{{ 'kyc_form_subtitle' | translate }}</p>

            @if (error()) {
              <c-alert color="danger">{{ error() }}</c-alert>
            }

            <form [formGroup]="kycForm" (ngSubmit)="onSubmit()">
              <!-- Name row -->
              <c-row class="mb-3">
                <c-col xs="12" md="6">
                  <label class="form-label" for="kyc_first_name">{{ 'kyc_first_name' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_first_name"
                    formControlName="kyc_first_name"
                    type="text"
                    [class.is-invalid]="kycForm.get('kyc_first_name')?.invalid && kycForm.get('kyc_first_name')?.touched"
                  />
                  @if (kycForm.get('kyc_first_name')?.invalid && kycForm.get('kyc_first_name')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>

                <c-col xs="12" md="6">
                  <label class="form-label" for="kyc_last_name">{{ 'kyc_last_name' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_last_name"
                    formControlName="kyc_last_name"
                    type="text"
                    [class.is-invalid]="kycForm.get('kyc_last_name')?.invalid && kycForm.get('kyc_last_name')?.touched"
                  />
                  @if (kycForm.get('kyc_last_name')?.invalid && kycForm.get('kyc_last_name')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>
              </c-row>

              <!-- Birthday + Phone -->
              <c-row class="mb-3">
                <c-col xs="12" md="6">
                  <label class="form-label" for="kyc_birthday">{{ 'kyc_birthday' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_birthday"
                    formControlName="kyc_birthday"
                    type="date"
                    [class.is-invalid]="kycForm.get('kyc_birthday')?.invalid && kycForm.get('kyc_birthday')?.touched"
                  />
                  @if (kycForm.get('kyc_birthday')?.invalid && kycForm.get('kyc_birthday')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>

                <c-col xs="12" md="6">
                  <label class="form-label" for="kyc_phone">{{ 'kyc_phone' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_phone"
                    formControlName="kyc_phone"
                    type="tel"
                    [class.is-invalid]="kycForm.get('kyc_phone')?.invalid && kycForm.get('kyc_phone')?.touched"
                  />
                  @if (kycForm.get('kyc_phone')?.invalid && kycForm.get('kyc_phone')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>
              </c-row>

              <!-- Address -->
              <c-row class="mb-3">
                <c-col xs="12">
                  <label class="form-label" for="kyc_address">{{ 'kyc_address' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_address"
                    formControlName="kyc_address"
                    type="text"
                    [class.is-invalid]="kycForm.get('kyc_address')?.invalid && kycForm.get('kyc_address')?.touched"
                  />
                  @if (kycForm.get('kyc_address')?.invalid && kycForm.get('kyc_address')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>
              </c-row>

              <c-row class="mb-3">
                <c-col xs="12">
                  <label class="form-label" for="kyc_address2">{{ 'kyc_address2' | translate }}</label>
                  <input
                    cFormControl
                    id="kyc_address2"
                    formControlName="kyc_address2"
                    type="text"
                  />
                </c-col>
              </c-row>

              <!-- City + Postcode -->
              <c-row class="mb-3">
                <c-col xs="12" md="6">
                  <label class="form-label" for="kyc_city">{{ 'kyc_city' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_city"
                    formControlName="kyc_city"
                    type="text"
                    [class.is-invalid]="kycForm.get('kyc_city')?.invalid && kycForm.get('kyc_city')?.touched"
                  />
                  @if (kycForm.get('kyc_city')?.invalid && kycForm.get('kyc_city')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>

                <c-col xs="12" md="6">
                  <label class="form-label" for="kyc_postcode">{{ 'kyc_postcode' | translate }} *</label>
                  <input
                    cFormControl
                    id="kyc_postcode"
                    formControlName="kyc_postcode"
                    type="text"
                    [class.is-invalid]="kycForm.get('kyc_postcode')?.invalid && kycForm.get('kyc_postcode')?.touched"
                  />
                  @if (kycForm.get('kyc_postcode')?.invalid && kycForm.get('kyc_postcode')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>
              </c-row>

              <!-- Country + State -->
              <c-row class="mb-3">
                <c-col xs="12" md="6">
                  <label class="form-label">{{ 'kyc_country' | translate }} *</label>

                  @if (countriesError()) {
                    <c-alert color="danger" class="py-2">
                      {{ 'kyc_countries_load_error' | translate }}
                    </c-alert>
                  }

                  @if (countriesLoaded()) {
                    <c-multi-select
                      formControlName="kyc_country_code"
                      [search]="true"
                      [multiple]="false"
                      [class.is-invalid]="kycForm.get('kyc_country_code')?.invalid && kycForm.get('kyc_country_code')?.touched"
                    >
                      @for (country of countries(); track country.value) {
                        <c-multi-select-option [value]="country.value">
                          {{ country.label }}
                        </c-multi-select-option>
                      }
                    </c-multi-select>
                  } @else if (!countriesError()) {
                    <div class="d-flex align-items-center gap-2 py-2" style="color: rgba(255,255,255,0.5)">
                      <c-spinner size="sm"></c-spinner>
                      <span>{{ 'kyc_countries_loading' | translate }}</span>
                    </div>
                  }

                  @if (kycForm.get('kyc_country_code')?.invalid && kycForm.get('kyc_country_code')?.touched) {
                    <div class="invalid-feedback">
                      {{ 'kyc_field_required' | translate }}
                    </div>
                  }
                </c-col>

                @if (hasStates()) {
                  <c-col xs="12" md="6">
                    <label class="form-label">{{ 'kyc_state' | translate }}</label>
                    <c-multi-select
                      formControlName="kyc_state_code"
                      [search]="true"
                      [multiple]="false"
                    >
                      @for (state of computedStates(); track state.value) {
                        <c-multi-select-option [value]="state.value">
                          {{ state.label }}
                        </c-multi-select-option>
                      }
                    </c-multi-select>
                  </c-col>
                }
              </c-row>

              <!-- Submit -->
              <c-row class="mt-4">
                <c-col>
                  <button
                    cButton
                    color="primary"
                    type="submit"
                    [disabled]="submitting()"
                  >
                    @if (submitting()) {
                      <c-spinner size="sm" class="me-2"></c-spinner>
                    }
                    {{ 'kyc_submit' | translate }}
                  </button>
                </c-col>
              </c-row>
            </form>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>